import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { ViewType } from "./types";
import { formatDateWithOptions } from '@/utils/Date';

interface CalendarHeaderProps {
  currentDate: Date;
  view: ViewType;
  onViewChange: (view: ViewType) => void;
  onPrevious: () => void;
  onNext: () => void;
  onToday: () => void;
}

const CalendarHeader: React.FC<CalendarHeaderProps> = ({
  currentDate,
  view,
  onPrevious,
  onNext,
  onToday,
}) => {
  const formatTitle = () => {
    const options: Intl.DateTimeFormatOptions =
      view === "month"
        ? { month: "long", year: "numeric" }
        : view === "week"
          ? { month: "short", day: "numeric", year: "numeric" }
          : { weekday: "long", month: "long", day: "numeric", year: "numeric" };

    return formatDateWithOptions(currentDate, options, "en-US");
  };

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div className="flex items-center flex-wrap gap-3">
        <button
          onClick={onToday}
          className="px-4 py-2 text-sm font-medium rounded-full border border-gray-400 bg-gray-100 hover:bg-gray-200 shadow-sm transition-colors"
        >
          Today
        </button>
        <div className="flex items-center rounded-full overflow-hidden">
          <button
            onClick={onPrevious}
            aria-label="Previous"
            className="p-2 hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-inset"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button
            onClick={onNext}
            aria-label="Next"
            className="p-2 hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-inset"
          >
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>
        <h1 className="text-xl font-semibold text-gray-900 tracking-wide">
          {formatTitle()}
        </h1>
      </div>
    </div>
  );
};

export default CalendarHeader;
